import VerofreshRecord from './VerofreshRecord'

class BannerRecord extends VerofreshRecord {
  static getBannerTypes () {
    return [
      'ctm_interruption',
      'route_plan_feed_interruption',
      'no_future_route_plan',
      'general'
    ]
  }
}

export default BannerRecord
